// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__gcHww","page":"pagination_page__1W3Zl","page_active":"pagination_page_active__BfosC","page_small":"pagination_page_small__+LxEb"};